(() => {
  'use strict';
  if (window.__gnwSlideshowV5) return;
  window.__gnwSlideshowV5 = true;
  const instances = new Map();
  class GnwSlideshow {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll('[data-gnw-slide]')];
      this.dots = [...root.querySelectorAll('[data-gnw-go]')];
      this.index = 0;
      this.delay = Math.max(5000, Number(root.dataset.interval) || 7000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.auto = root.dataset.autoplay === 'true';
      this.paused = this.motion.matches || !this.auto;
      this.explicitPlay = false;
      this.hovered = false; this.focused = false; this.visible = true;
      this.abort = new AbortController();
      this.signal = this.abort.signal;
      this.pauseButton = root.querySelector('[data-gnw-pause]');
      this.count = root.querySelector('[data-gnw-count]');
      this.status = root.querySelector('[data-gnw-status]');
      if (this.slides.length < 2) return;
      this.listen(root, 'click', e => {
        const button = e.target.closest('button');
        if (!button) return;
        if (button.matches('[data-gnw-prev]')) this.manual(this.index - 1);
        if (button.matches('[data-gnw-next]')) this.manual(this.index + 1);
        if (button.matches('[data-gnw-go]')) this.manual(Number(button.dataset.gnwGo));
        if (button.matches('[data-gnw-pause]')) {
          this.paused = !this.paused;
          this.explicitPlay = !this.paused;
          // Explicit play is permitted after the user has chosen to resume.
          this.updateButton(); this.schedule();
        }
      });
      this.listen(root, 'keydown', e => {
        if (!e.target.closest('[data-gnw-controls]')) return;
        if (e.key === 'ArrowLeft') {e.preventDefault(); this.manual(this.index - 1);}
        if (e.key === 'ArrowRight') {e.preventDefault(); this.manual(this.index + 1);}
      });
      this.listen(root, 'pointerenter', e => {if (e.pointerType === 'mouse') {this.hovered = true; this.explicitPlay = false; this.schedule();}});
      this.listen(root, 'pointerleave', () => {this.hovered = false; this.schedule();});
      this.listen(root, 'focusin', () => {this.focused = true; this.explicitPlay = false; this.schedule();});
      this.listen(root, 'focusout', () => {queueMicrotask(() => {this.focused = root.contains(document.activeElement); this.schedule();});});
      let start;
      this.listen(root.querySelector('[data-gnw-track]'), 'pointerdown', e => {
        if (e.pointerType === 'mouse' || e.target.closest('a,button,input')) return;
        start = {x:e.clientX, y:e.clientY};
      });
      this.listen(root, 'pointerup', e => {
        if (!start) return;
        const dx = e.clientX - start.x, dy = e.clientY - start.y; start = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.manual(this.index + (dx < 0 ? 1 : -1));
      });
      this.listen(root, 'pointercancel', () => {start = null;});
      this.listen(document, 'visibilitychange', () => this.schedule());
      this.listen(this.motion, 'change', e => {if (e.matches) this.paused = true; this.updateButton(); this.schedule();});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.schedule();},{threshold:.15});
        this.observer.observe(root);
      }
      this.listen(document, 'shopify:block:select', e => {
        const selected = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
        if (selected >= 0) this.manual(selected);
      });
      this.updateButton(); this.schedule();
    }
    listen(target, type, fn) { if (target) target.addEventListener(type, fn, {signal:this.signal}); }
    normalized(index) {return (index + this.slides.length) % this.slides.length;}
    load(index) {
      this.slides[this.normalized(index)].querySelectorAll('[data-gnw-srcset], [data-gnw-src]').forEach(el => {
        if (el.dataset.gnwSrcset) {el.setAttribute('srcset', el.dataset.gnwSrcset);delete el.dataset.gnwSrcset;}
        if (el.dataset.gnwSrc) {el.setAttribute('src', el.dataset.gnwSrc);delete el.dataset.gnwSrc;}
      });
    }
    show(index, announce = false) {
      this.index = this.normalized(index); this.load(this.index);
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index; slide.inert = i !== this.index;
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.dots.forEach((dot, i) => {if(i === this.index) dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      if(this.count) this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
      if(announce && this.status) this.status.textContent = this.dots[this.index].getAttribute('aria-label');
      this.schedule();
    }
    manual(index) {this.show(index, true);}
    updateButton() {
      if (!this.pauseButton) return;
      this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause;
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
    }
    schedule() {
      clearTimeout(this.timer);clearTimeout(this.preload);
      if (this.paused || ((this.hovered || this.focused) && !this.explicitPlay) || !this.visible || document.hidden || this.slides.length < 2) return;
      this.preload = setTimeout(() => this.load(this.index + 1), this.delay - 1200);
      this.timer = setTimeout(() => this.show(this.index + 1), this.delay);
    }
    destroy() {clearTimeout(this.timer);clearTimeout(this.preload);this.abort.abort();if(this.observer)this.observer.disconnect();}
  }
  const init = (scope=document) => {
    scope.querySelectorAll('[data-gnw-slideshow]').forEach(root => {
      if(instances.has(root))return;
      instances.set(root,new GnwSlideshow(root));
    });
  };
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    instances.forEach((instance,root)=>{if(e.target.contains(root)){instance.destroy();instances.delete(root);}});
  });
})();
